/* eslint-disable */
import { useEffect } from 'react';
import useTheme from 'src/hooks/useTheme';
import useHistory from 'src/hooks/useHistory';
import './index.scss';

const ThemeSwitch = () => {
  const { theme, setTheme, themeKey } = useTheme();
  const { searchParams, updateSearchParams } = useHistory();

  const isDarkTheme = theme === 'dark';

  useEffect(() => {
    updateSearchParams(themeKey, theme);
  }, [searchParams, theme, updateSearchParams]);

  return (
    <button
      className={`theme-toggle ${isDarkTheme ? 'theme-toggle--dark' : 'theme-toggle--light'}`}
      onClick={() => setTheme(theme !== 'dark' ? 'dark' : 'light')}
      aria-label={`Switch to ${isDarkTheme ? 'light' : 'dark'} mode`}
    >
      <div className="toggle-track">
        <span className="toggle-icon toggle-icon--sun">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="5"/>
            <line x1="12" y1="1" x2="12" y2="3"/>
            <line x1="12" y1="21" x2="12" y2="23"/>
            <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/>
            <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
            <line x1="1" y1="12" x2="3" y2="12"/>
            <line x1="21" y1="12" x2="23" y2="12"/>
            <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/>
            <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
          </svg>
        </span>
        <span className="toggle-icon toggle-icon--moon">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
          </svg>
        </span>
        <div className={`toggle-thumb ${isDarkTheme ? 'checked' : ''}`} />
      </div>
    </button>
  );
};

export default ThemeSwitch;
